<ng-template>
  <item-automation [formControl]="formControl" [itemTitle]="itemTitle" [itemType]="itemType"></item-automation>
</ng-template>
